import { Trans } from '@lingui/react'
import { isNil } from 'ramda'

import type { ArticleListResponse } from '@twisto/api-cms'
import { Typography } from '@twisto/components/atoms/typography'
import { useIsMobile } from '@twisto/hooks'

import { ContentListLink } from '../subcategory-list/subcategory-content-list/'

import * as styles from './popular-article-list.styles'

type Props = {
  articles?: ArticleListResponse
}

const MAX_MOBILE_ARTICLES = 6

export const PopularArticleList = ({ articles }: Props) => {
  const isMobile = useIsMobile()
  if (isNil(articles) || isNil(articles.data) || articles.data.length === 0) {
    return null
  }

  const slicedArticles = articles.data.slice(
    0,
    isMobile ? MAX_MOBILE_ARTICLES : articles.data.length
  )

  return (
    <section css={styles.section}>
      <nav css={styles.container}>
        <Typography
          color="textPrimary"
          component="h2"
          fontWeight="heavy"
          variant="h1"
        >
          <Trans id="popularArticleList.title" />
        </Typography>
        <ul css={styles.list}>
          {slicedArticles.map((article) => (
            <ContentListLink
              key={article.id}
              css={styles.listItem}
              text={article.headline}
              to={article.path}
            />
          ))}
        </ul>
      </nav>
    </section>
  )
}
